<template>
  <div class="submit-modal">
    <header>腾讯电商服务开通</header>
    <div class="wrap">
      <div>
        <div class="content">
          <div class="icon">
            <img class="custom-icon" src="../../assets/icon-success@2x.png" alt>
          </div>
          <div>
            <h4 class="title">
              实名认证通过！
            </h4>
            <!-- <p class="desc">您的审核结果将在24小时内通过短信通知</p> -->
          </div>
        </div>
        <div class="panel">
          <qc-button class="custom-btn" type="default" @click="onConfirm">
            我知道了
          </qc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubmitModal',
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>


<style lang="less" scoped>
.submit-modal {
  width: 500px;
  height: 248px;
  background-color: #fff;
  border-radius: 4px;
  header {
    height: 50px;
    display: flex;
    align-items: center;
    background-color: #0037ff;
    color: #fff;
    border-radius: 4px 4px 0 0;
    font-size: 16px;
    padding-left: 20px;
  }
  .wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 198px;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      margin-right: 20px;
    }
    .title {
      font-size: 18px;
      font-weight: normal;
    }
  }
  .panel {
    text-align: center;
    margin-top: 20px;
  }
  .custom-btn {
    width: 120px;
    height: 40px;
    border-radius: 4px;
  }
  .custom-icon {
    width: 42px;
    height: 42px;
  }
}
</style>
